"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var react_router_dom_1 = require("react-router-dom");
var memoize = require("fast-memoize");
var Types = require("types");
var sok_ui_1 = require("@caddigital/sok-ui");
var bid_1 = require("@caddigital/sok-reducers/lib/actions/bid");
var BidUserGroupActions = require("@caddigital/sok-reducers/lib/actions/bid/userGroups");
var ProjectHomeActions = require("@caddigital/sok-reducers/lib/actions/project/home");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var translate_1 = require("utils/translate");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var fileListFilter_1 = require("utils/helpers/fileListFilter");
var FilesRouter_1 = require("../FilesRouter");
var BasicInformationView_1 = require("views/BidViews/BasicInformationView");
var ParticipantsView_1 = require("views/BidViews/ParticipantsView");
var MessagesView_1 = require("views/BidViews/MessagesView");
var ShoppingCart_1 = require("components/sidemenus/ShoppingCart");
var TendersCardView_1 = require("views/BidViews/TendersCardView");
var AdditionalLettersView_1 = require("views/AdditionalLettersView");
var bidListActions = require("@caddigital/sok-reducers/lib/actions/bid/list");
var MessageView_1 = require("views/BidViews/MessageView");
var QuestionsAndAnswersView_1 = require("views/BidViews/QuestionsAndAnswersView");
var ViewHeader_1 = require("views/FileListOverview/ViewHeader");
var ListHeader_1 = require("views/BidViews/DocumentsView/ListHeader");
var ListRow_1 = require("views/BidViews/DocumentsView/ListRow");
var fileUploadModal_1 = require("actions/fileUploadModal");
var NavigationMenu_1 = require("views/BidViews/NavigationMenu");
var Tools_1 = require("views/FileListOverview/Tools");
var mapStateToProps = function (state) { return ({
    current: state.bid.current,
    currentAddendum: state.bid.currentAddendum,
    project: state.project.currentProject,
    metadata: state.files.metadata,
    saveStatus: state.bid.basicInformation.saveStatus,
    user: state.auth.current.user,
    selectedLanguage: (0, translate_1.getLanguage)()
}); };
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    fetch: function (id) { return dispatch(bid_1.CurrentBid.fetchRequest(id)); },
    fetchAddendum: function (id) { return dispatch(bid_1.CurrentAddendums.fetchRequest(id)); },
    fetchList: function (briefcase) {
        return dispatch(bidListActions.fetchRequest(briefcase));
    },
    fetchProject: function (id) {
        return dispatch(ProjectHomeActions.fetchProjectByIdRequest(id));
    },
    setFileUploadModalDescription: function (description) {
        return dispatch(fileUploadModal_1.default.setFileUploadModalDescription(description));
    },
    toggleUploadModal: function () {
        dispatch(fileUploadModal_1.default.toggleModalStatus());
    },
    appendUploadFiles: function (files, location, parent) { return dispatch(fileUploadModal_1.default.setFileUploadFiles(files, location, parent)); },
    clearCurrentAddendum: function () { return dispatch(bid_1.CurrentAddendums.clear()); },
    clear: function () {
        dispatch(bid_1.CurrentBid.clear());
        dispatch(bid_1.CurrentAddendums.clear());
        dispatch(BidUserGroupActions.clear());
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentWillMount: function () {
        var params = this.props.match.params;
        var bidId = NaN;
        if (params[0] === 'letter' && params.letterId !== undefined) {
            this.props.fetchAddendum(parseInt(params.letterId, 10));
        }
        if (isNaN(bidId) && params.bid !== undefined) {
            this.props.fetch(parseInt(params.bid, 10));
        }
    },
    componentDidUpdate: function (prevProps) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        if (((_b = (_a = this.props.currentAddendum) === null || _a === void 0 ? void 0 : _a.bid) === null || _b === void 0 ? void 0 : _b.id) !==
            ((_d = (_c = prevProps.currentAddendum) === null || _c === void 0 ? void 0 : _c.bid) === null || _d === void 0 ? void 0 : _d.id) ||
            ((_e = this.props.current.bid) === null || _e === void 0 ? void 0 : _e.id) !== ((_f = prevProps.current.bid) === null || _f === void 0 ? void 0 : _f.id)) {
            var currentAddendumId = (_h = (_g = this.props.currentAddendum) === null || _g === void 0 ? void 0 : _g.bid) === null || _h === void 0 ? void 0 : _h.id;
            var isCurrentAddendum = currentAddendumId !== undefined && currentAddendumId !== null;
            var localizationKey = "fileUploadModal/description/".concat(isCurrentAddendum ? 'addendum' : 'bid');
            var entityName = isCurrentAddendum
                ? (_k = (_j = this.props.currentAddendum) === null || _j === void 0 ? void 0 : _j.bid) === null || _k === void 0 ? void 0 : _k.name
                : (_l = this.props.current.bid) === null || _l === void 0 ? void 0 : _l.name;
            var fileUploadModalDescription = (0, translation_1.getLocalization)(localizationKey, [
                entityName !== null && entityName !== void 0 ? entityName : String()
            ]);
            this.props.setFileUploadModalDescription(fileUploadModalDescription);
        }
        if (prevProps.saveStatus !== 'ADDENDUMS_SAVED' &&
            this.props.saveStatus === 'ADDENDUMS_SAVED' &&
            this.props.currentAddendum.bid &&
            prevProps.currentAddendum.bid) {
            var url = "".concat(this.props.match.url, "/").concat(this.props.currentAddendum.bid.id);
            this.props.history.replace(url);
        }
        if ((this.props.project.status === 'STANDBY' &&
            this.props.current.status === 'FETCHED' &&
            this.props.current.bid) ||
            (this.props.project.status === 'FETCHED' &&
                this.props.project.project &&
                this.props.current.status === 'FETCHED' &&
                this.props.current.bid &&
                this.props.project.project.id !== this.props.current.bid.project) ||
            (this.props.current.status === 'FETCHED' &&
                this.props.current !== prevProps.current)) {
            if (this.props.current.bid) {
                this.props.fetchProject(this.props.current.bid.project);
            }
        }
        // redirect to new created bid
        if (prevProps.current.bid === null &&
            prevProps.saveStatus === 'SAVING' &&
            this.props.current.bid) {
            var url = "/".concat(this.props.selectedLanguage, "/briefcase/").concat(this.props.currentBriefcase.id, "/bid/").concat(this.props.current.bid.id);
            this.props.history.replace(url);
        }
        if (this.props.current.status === 'STANDBY' &&
            this.props.current.bid === null &&
            this.props.match.params.bid !== undefined) {
            this.props.fetch(parseInt(this.props.match.params.bid, 10));
        }
        if (this.props.match.params[0] === 'letter' &&
            this.props.match.params.letterId !== undefined) {
            var letterId = parseInt(this.props.match.params.letterId, 10);
            if (this.props.currentAddendum.status === 'STANDBY' &&
                !isNaN(letterId)) {
                this.props.fetchAddendum(parseInt(this.props.match.params.letterId, 10));
            }
        }
        if (this.props.match.params[0] !== 'letter' &&
            prevProps.match.params[0] === 'letter') {
            this.props.clearCurrentAddendum();
        }
    },
    componentWillUnmount: function () {
        this.props.clear();
    }
}), recompose_1.pure);
var Loading = function () { return (React.createElement("div", { className: 'bid-router-loading' },
    React.createElement("div", null,
        React.createElement(sok_ui_1.LoadingSpinner, null)))); };
var _FilesBreadCrumb = function (documents, parentBid) {
    return function (props) {
        var selectedLanguage = (0, translate_1.getLanguage)();
        var baseUrl = "/".concat(selectedLanguage);
        var currentBriefcase = props.currentBriefcase;
        var currentBid = props.currentBid;
        if (!currentBriefcase || !currentBid) {
            return React.createElement("div", null);
        }
        baseUrl = "".concat(baseUrl, "/briefcase/").concat(currentBriefcase.id);
        var path = props.path.filter(function (x) {
            return x.id !== currentBriefcase.id &&
                x.id !== currentBid.id &&
                x.id !== currentBid.parent &&
                x.id !== documents.id;
        });
        var isLetter = currentBriefcase.id !== currentBid.parent;
        return (React.createElement(sok_ui_1.BreadCrumb, null,
            React.createElement(react_router_dom_1.Link, { to: "/".concat(selectedLanguage, "/briefcase/").concat(currentBriefcase.id) }, currentBriefcase.name),
            parentBid && (React.createElement(react_router_dom_1.Link, { to: "/".concat(selectedLanguage, "/briefcase/").concat(currentBriefcase.id, "/bid/").concat(isLetter ? currentBid.parent : currentBid.id) }, parentBid.name)),
            parentBid && (React.createElement(react_router_dom_1.Link, { to: "/".concat(selectedLanguage, "/briefcase/").concat(currentBriefcase.id, "/bid/").concat(currentBid.parent, "/letters") }, (0, translation_1.getLocalization)('breadcrumb/sokobid/letters'))),
            React.createElement(react_router_dom_1.Link, { to: "/".concat(selectedLanguage, "/briefcase/").concat(currentBriefcase.id, "/bid/").concat(isLetter
                    ? "".concat(currentBid.parent, "/letter/").concat(currentBid.id)
                    : currentBid.id) }, currentBid.name),
            React.createElement(react_router_dom_1.Link, { to: "/".concat(selectedLanguage, "/briefcase/").concat(currentBriefcase.id, "/bid/").concat(isLetter
                    ? "".concat(currentBid.parent, "/letter/").concat(currentBid.id, "/files")
                    : "".concat(currentBid.id, "/documents"), "/").concat(documents.id), onClick: function () {
                    return props.clearAllColumnFilters && props.clearAllColumnFilters();
                } }, (0, translation_1.getLocalization)('breadcrumb/documents')),
            path.map(function (folder, index) {
                var url = "/".concat(selectedLanguage, "/briefcase/").concat(currentBriefcase.id, "/bid/").concat(isLetter
                    ? "".concat(currentBid.parent, "/letter/").concat(currentBid.id, "/files")
                    : "".concat(currentBid.id, "/documents"), "/").concat(folder.id);
                return (React.createElement(react_router_dom_1.Link, { className: 'sok-breadcrumb-link', key: "".concat(index, "-").concat(folder.id), to: url }, folder.name));
            }),
            props.searchResultsToggled && (React.createElement("span", { className: 'sok-breadcrumb-link', onClick: function () {
                    return props.navigateTo &&
                        props.navigateTo("/".concat(selectedLanguage, "/briefcase/").concat(currentBriefcase.id, "/bid/").concat(isLetter
                            ? "".concat(currentBid.parent, "/letter/").concat(currentBid.id, "/files")
                            : "".concat(currentBid.id, "/documents"), "/").concat(path[path.length - 1].id), true);
                } }, (0, translation_1.getLocalization)('breadcrumb/projectname/searchResults').toLocaleLowerCase())),
            props.filtering !== 'NONE' && (React.createElement("span", null, (0, fileListFilter_1.getFiltering)(props.filtering))),
            props.children));
    };
};
var FilesBreadCrumb = memoize(_FilesBreadCrumb);
exports.default = enhance(function (routerProps) {
    var baseUrl = routerProps.baseUrl;
    var url = routerProps.match.url;
    var currentBriefcase = routerProps.currentBriefcase;
    var selectedLanguage = routerProps.selectedLanguage;
    var currentBid = routerProps.current.bid;
    var currentAddendum = routerProps.currentAddendum.bid;
    var currentBidStatus = routerProps.current.status;
    var bidDocuments = routerProps.current.documents;
    var addendumDocuments = routerProps.currentAddendum.documents;
    var project = routerProps.project;
    var params = routerProps.match.params;
    var metadata = routerProps.metadata;
    if (routerProps.current.status === 'FETCHING' ||
        routerProps.currentAddendum.status === 'FETCHING' ||
        ((params.bid !== undefined ||
            (params[0] === 'letter' && params.letterId !== undefined)) &&
            routerProps.current.status === 'STANDBY') ||
        (currentBid &&
            params[0] !== 'letter' &&
            params.bid !== currentBid.id.toString())) {
        return React.createElement(Loading, null);
    }
    else if (routerProps.current.status === 'FAILED' ||
        (params.letterId !== undefined &&
            routerProps.currentAddendum.status === 'FAILED')) {
        return (React.createElement("div", { className: 'bid-router-error' },
            React.createElement(GenericErrorMessage_1.default, null)));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(react_router_dom_1.Switch, null,
            React.createElement(react_router_dom_1.Route, { key: 'additionalLetters', exact: true, path: baseUrl + "/letters", render: function (props) {
                    if (!currentBid)
                        return React.createElement(Loading, null);
                    return (React.createElement(AdditionalLettersView_1.default, __assign({}, props, { currentBid: currentBid, currentBriefcase: currentBriefcase })));
                } }),
            currentBid && routerProps.current.documents && (React.createElement(react_router_dom_1.Redirect, { exact: true, key: 'files', from: baseUrl + "/documents/", to: "/".concat(routerProps.selectedLanguage, "/briefcase/").concat(currentBriefcase.id, "/bid/").concat(currentBid.id, "/documents/").concat(routerProps.current.documents.id) })),
            currentBid && bidDocuments && (React.createElement(react_router_dom_1.Route, { key: 'documents', path: baseUrl + "/documents/:folderId", render: function (props) {
                    return (React.createElement(React.Fragment, null,
                        React.createElement(ShoppingCart_1.default, { feature: 'sokobid', baseUrl: url, rootFolder: bidDocuments.id }),
                        React.createElement(FilesRouter_1.default, __assign({}, props, { BreadCrumb: FilesBreadCrumb(bidDocuments), Tools: Tools_1.default, ViewHeader: ViewHeader_1.ViewHeader, ListHeader: ListHeader_1.ListHeader, staticIconCount: 5, staticIconCountMobile: 3, ListRow: ListRow_1.ListRow, metadata: metadata, toggleUploadModal: routerProps.toggleUploadModal, appendUploadFiles: routerProps.appendUploadFiles, selectedLanguage: selectedLanguage, rootFolder: bidDocuments, currentProject: project.status === 'FETCHED' ? project.project : undefined, currentBid: currentBid, currentBriefcase: currentBriefcase, showFolderTree: false }))));
                } })),
            currentAddendum && addendumDocuments && (React.createElement(react_router_dom_1.Route, { key: 'additional-letter-documents', path: baseUrl + '/letter/:letterId/files/:folderId', render: function (props) {
                    var letter = props.match.params && props.match.params.letterId
                        ? props.match.params.letterId
                        : null;
                    var letterId = letter ? parseInt(letter, 10) : undefined;
                    if (letterId === undefined) {
                        return React.createElement("div", null);
                    }
                    if (currentBidStatus === 'FETCHING') {
                        return React.createElement(Loading, null);
                    }
                    return (React.createElement(React.Fragment, null,
                        React.createElement(ShoppingCart_1.default, { feature: 'sokobid', baseUrl: url, rootFolder: addendumDocuments.id }),
                        React.createElement(FilesRouter_1.default, __assign({}, props, { BreadCrumb: FilesBreadCrumb(addendumDocuments, currentBid), Tools: Tools_1.default, toggleUploadModal: routerProps.toggleUploadModal, metadata: metadata, appendUploadFiles: routerProps.appendUploadFiles, ViewHeader: function (props) { return (React.createElement(React.Fragment, null,
                                letter && (React.createElement(NavigationMenu_1.default, __assign({}, props, { mode: 'MODIFY', type: 'ADDITIONAL', currentBid: currentBid, currentAddendum: currentAddendum, currentBriefcase: currentBriefcase, page: 1 }))),
                                React.createElement(ViewHeader_1.ViewHeader, __assign({}, props)))); }, staticIconCount: 5, staticIconCountMobile: 3, ListHeader: ListHeader_1.ListHeader, ListRow: ListRow_1.ListRow, selectedLanguage: selectedLanguage, currentProject: project.status === 'FETCHED' ? project.project : undefined, rootFolder: addendumDocuments, currentBid: currentAddendum, currentBriefcase: currentBriefcase, showFolderTree: false }))));
                } })),
            React.createElement(react_router_dom_1.Route, { exact: true, key: 'participants', path: baseUrl + "/participants", render: function (props) {
                    if (!currentBid)
                        return React.createElement(Loading, null);
                    return (React.createElement(ParticipantsView_1.default, __assign({}, props, { currentBid: currentBid, currentBriefcase: currentBriefcase })));
                } }),
            React.createElement(react_router_dom_1.Route, { key: 'tenderscard', path: baseUrl + "/participants/:participantId", render: function (props) {
                    if (!currentBid)
                        return React.createElement(Loading, null);
                    return (React.createElement(TendersCardView_1.default, __assign({}, props, { currentBid: currentBid, baseUrl: props.match.url, currentBriefcase: currentBriefcase })));
                } }),
            React.createElement(react_router_dom_1.Route, { exact: true, key: 'messages', path: baseUrl + "/messages", render: function (props) {
                    if (!currentBid)
                        return React.createElement(Loading, null);
                    return (React.createElement(MessagesView_1.default, __assign({}, props, { currentBid: currentBid, currentBriefcase: currentBriefcase })));
                } }),
            React.createElement(react_router_dom_1.Route, { exact: true, key: 'messages', path: baseUrl + "/message/:messageId?", render: function (props) {
                    if (!currentBid)
                        return React.createElement(Loading, null);
                    return (React.createElement(MessageView_1.default, __assign({}, props, { currentBid: currentBid, currentBriefcase: currentBriefcase })));
                } }),
            React.createElement(react_router_dom_1.Route, { key: 'questionsAndAnswers', path: baseUrl + "/questionsAndAnswers", render: function (props) {
                    if (!currentBid)
                        return React.createElement(Loading, null);
                    return (React.createElement(QuestionsAndAnswersView_1.default, __assign({}, props, { currentBid: currentBid, currentBriefcase: currentBriefcase })));
                } }),
            React.createElement(react_router_dom_1.Route, { key: 'basicInformaion', exact: true, path: baseUrl + '/(letter)?/:letterId?', render: function (props) {
                    // as default create mew bid
                    var mode = 'CREATE';
                    var type = 'BID';
                    if (props.match.params[0] === 'letter') {
                        type = 'ADDITIONAL';
                        var letterId = props.match.params.letterId
                            ? parseInt(props.match.params.letterId, 10)
                            : undefined;
                        if (letterId !== undefined && !isNaN(letterId)) {
                            mode = 'MODIFY';
                        }
                    }
                    else {
                        var bidId = props.match.params
                            ? parseInt(props.match.params.bid, 10)
                            : undefined;
                        if (bidId !== undefined && !isNaN(bidId)) {
                            mode = 'MODIFY';
                        }
                    }
                    var params = {
                        mode: mode,
                        type: type,
                        currentBriefcase: currentBriefcase,
                        currentBid: currentBid,
                        currentAddendum: currentAddendum
                    };
                    return (React.createElement(BasicInformationView_1.default, __assign({}, props, params, { currentBriefcase: currentBriefcase, key: 'bid-basic-information' })));
                } }))));
});
